import { render } from "./TreeParent.vue?vue&type=template&id=ba358ea2"
import script from "./TreeParent.vue?vue&type=script&lang=js"
export * from "./TreeParent.vue?vue&type=script&lang=js"
script.render = render

export default script